import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const HeaderMenu = [
  {
    name:"Home",
    url:"#home",
  },
  {
    name:"Students",
    url:"#cloud",
  },
  {
    name:"Alumni",
    url:"#doctors",
  },
  {
    name:"Institution",
    url:"#hospital",
  },
  {
    name:"Pricing",
    url:"#pricing",
  },
  {
    name:"Privacy Policy",
    url:"/privacy-policy",
  },
  {
    name:"Account",
    url:"/delete-user-request",
  }
]

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileNav, setMobileNav] = useState(false);

  console.log('location',location);
  return (
    <header className="main_header">
      <div className="container">
        <div className="logo" onClick={() => navigate("/")}>
          <h2>
          <i class="fa-solid fa-graduation-cap"></i> India Alumni
          </h2>
        </div>
        <div className="navlist">
          <ul>
            {HeaderMenu?.map((menu,idx)=>(
              <a href={menu?.url}><li className={menu?.url==location?.hash?"nav_active":""}>{menu?.name}</li></a>
            ))}
            {/* <li>
              Pages <i class="fa-solid fa-chevron-down"></i>
            </li> */}
          </ul>
        </div>
        {mobileNav && (
          <div className="navlist_mobile">
            <ul>
            {HeaderMenu?.map((menu,idx)=>(
              <a href={menu?.url}><li className={menu?.url==location?.hash?"nav_active":""}>{menu?.name}</li></a>
            ))}
              {/* <li>
                Pages <i class="fa-solid fa-chevron-down"></i>
              </li> */}
            </ul>
            <button className="btn_one">Get Started</button>
          </div>
        )}
        <div className="action_btns">
          <button className="btn_one">Get Started</button>
          {mobileNav ? (
            <i
              class="fa-solid fa-xmark"
              onClick={() => setMobileNav(!mobileNav)}
            ></i>
          ) : (
            <i
              class="fa-solid fa-bars"
              onClick={() => setMobileNav(!mobileNav)}
            ></i>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
